export default __webpack_public_path__ + "static/media/shirts.3664ff7c.png";